import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumValue } from "@/Models/Validators/MaximumValue";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import GroupedValidator from '../Validators/GroupedValidator';
import { ShapeCategory } from '@/types/shapeCategories';

export default class SlopedRectangleConfiguration implements ShapeConfigurationInterface {
	get_dimension_keys(): string[] {
		return [
			'height_left',
			'width',
			'height_right',
		];
	}

	get_modifier_keys(): string[] {
		return [];
	}

	get_maximum_dimensions( maximum_rectangle ): Record<string, Length> {
		return {
			width: maximum_rectangle.get_width(),
			height_left: maximum_rectangle.get_longest_side(),
			height_right: maximum_rectangle.get_longest_side(),
		};
	}

	get_labels(): Record<string, string> {
		const { width, height_left, height_right } = window.measurementSelectorVariables.i18n.dimensionNames;

		return {
			width,
			height_left,
			height_right,
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		const { at_least_one } = window.measurementSelectorVariables.i18n.validators.dimensions;

		return {
			height_left: [ MaximumDecimalPoints, MaximumValue ],
			height_right: [ MaximumDecimalPoints, MaximumValue ],
			width: [ MaximumDecimalPoints, MaximumValue ],
			grouped: [
				new GroupedValidator(
					MinimumValue,
					[ 'height_left', 'height_right', 'width' ],
					'sloped-rectangle_minimum',
					at_least_one.min
				)
			]
		};
	}

	get_category(): ShapeCategory {
		return 'straight';
	}
}
